// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"53de2438","15":"b8ee8f43","241":"0eaeeb25","496":"a0983616","725":"0faab800","781":"84a9b7d4"}[chunkId] + ".chunk.js";
};